import * as Sentry from '@sentry/react';

const GLITCHTIP_DSN = 'https://7d0ef909ef70470e90cfd07082b251a9@monitoring.africaresortos.com/1';

export function sentryInit(): void {
  if (import.meta.env.DEV) return;

  console.log('[DEBUG] Sentry init');

  Sentry.init({
    dsn: GLITCHTIP_DSN,
    tracesSampleRate: 0.01,
    ...({ autoSessionTracking: false } as any),
  });
}

export { Sentry };
